/**
 * Les périodes de déclaration et de reporting sont TRIMESTRIELLES : T1 (janvier
 * → mars) à T4 (octobre → décembre). Les collaborateurs ont une semaine de
 * plus après la fin du trimestre pour saisir les déplacements de ses derniers
 * jours : la date limite de saisie tombe à fin de trimestre + 7 jours. Les
 * managers valident jusqu'à fin de trimestre + 10 jours ; passé cette date, la
 * RH reprend la main sur ce qui reste à valider (workflow.niveauDecision).
 *
 * Partagé : l'écran d'administration propose le trimestre, la démo construit
 * les siens, et les deux tombent sur les mêmes dates.
 */
/** Délai de saisie accordé après la fin d'un trimestre, en jours. */
export const DELAI_SAISIE_JOURS = 7;
/** Délai de validation des managers après la fin d'un trimestre, en jours. */
export const DELAI_VALIDATION_JOURS = 10;
const iso = (d) => d.toISOString().slice(0, 10);
/** Ajoute (ou retire) des jours à une date AAAA-MM-JJ, sans dépendre du fuseau. */
export function decalerJours(date, jours) {
    const d = new Date(`${date}T00:00:00Z`);
    d.setUTCDate(d.getUTCDate() + jours);
    return iso(d);
}
export function trimestre(annee, numero) {
    const debut = new Date(Date.UTC(annee, (numero - 1) * 3, 1));
    // Le jour 0 du mois qui suit le trimestre : son dernier jour, février bissextile compris.
    const fin = new Date(Date.UTC(annee, numero * 3, 0));
    const dateFin = iso(fin);
    return {
        annee,
        numero,
        libelle: `T${numero} ${annee}`,
        dateDebut: iso(debut),
        dateFin,
        dateLimite: decalerJours(dateFin, DELAI_SAISIE_JOURS),
        dateLimiteValidation: decalerJours(dateFin, DELAI_VALIDATION_JOURS),
    };
}
/** Le trimestre qui contient une date AAAA-MM-JJ. */
export function trimestreDe(date) {
    const annee = Number(date.slice(0, 4));
    const mois = Number(date.slice(5, 7));
    return trimestre(annee, (Math.floor((mois - 1) / 3) + 1));
}
/** Le trimestre décalé de `n` trimestres (négatif : vers le passé). */
export function trimestreDecale(t, n) {
    const rang = t.annee * 4 + (t.numero - 1) + n;
    return trimestre(Math.floor(rang / 4), ((rang % 4) + 1));
}
/** Vrai si les dates bornent exactement un trimestre civil. */
export function estTrimestre(dateDebut, dateFin) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateDebut))
        return false;
    const t = trimestreDe(dateDebut);
    return t.dateDebut === dateDebut && t.dateFin === dateFin;
}
/**
 * Date limite de validation par défaut d'une période : fin + DELAI_VALIDATION_JOURS,
 * jamais avant la date limite de saisie (on ne ferme pas la validation de ce
 * qui peut encore être soumis).
 */
export function dateLimiteValidationParDefaut(p) {
    const d = decalerJours(p.dateFin, DELAI_VALIDATION_JOURS);
    return d > p.dateLimite ? d : p.dateLimite;
}
/** Vrai si, à la date `aujourdhui`, les managers ne peuvent plus valider sur cette période. */
export function validationManagerEchue(dateLimiteValidation, aujourdhui) {
    return !!dateLimiteValidation && aujourdhui > dateLimiteValidation;
}
//# sourceMappingURL=periodes.js.map